import React from 'react';
import { connect } from '@cerebral/react';
import { signal, state } from 'cerebral/tags';

import { View, Poster, Loader } from '../components';

class PosterPreview extends React.Component {
    state = {
        email: '',
        send: false,
    };
    sendMail = (e) => {
        e.preventDefault();
        const { email } = this.state;
        const { mailPdf, trackEvent } = this.props;

        const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (email && re.test(email.toLowerCase())) {
            mailPdf({ email });
            trackEvent({
                eventAction: 'pdf_mailed',
            });
            this.setState({
                send: true,
            });
        }
    };
    handleMailChange = (e) => {
        this.setState({
            email: e.target.value,
        });
    };
    render() {
        const { mailLoading, error } = this.props;
        const { email, send } = this.state;

        return (
            <View>
                <div className="page page-poster">
                    <div className="splitview">
                        <div className="split-left">
                            <Poster />
                        </div>
                        <div className="split-right">
                            <a
                                className="btn btn-primary mb-4"
                                href="#/"
                            >
                                <i className="bol-icon-icon_arrow_left" /> Vul
                                verder de vragen in.
                            </a>
                            <h3>Jouw poster</h3>
                            <p>
                                We hebben een poster voor jou samengesteld. Met{' '}
                                <strong>
                                    geheugensteuntjes, uitleg en tips
                                </strong>
                                . Helemaal op maat van wat je zelf invulde.
                            </p>
                            <p>
                                <strong>Enkel jij</strong> kan deze poster zien.
                                Klik op de knop ‘Bekijk de poster’ als je hem
                                wil downloaden of printen. Zo kan je hem
                                bijhouden of zelfs ergens ophangen.
                            </p>
                            <p>
                                <strong>
                                    Wil je liever niet dat iemand de poster kan
                                    vinden
                                </strong>{' '}
                                op je kamer of op de computer? Mail hem dan naar
                                jezelf, om te bewaren voor later.
                                <br />
                                Vul dan hieronder je e-mailadres in.
                            </p>
                            {error &&
                                <p>
                                    Er ging iets mis bij het versturen van
                                    jouw poster, probeer het later opnieuw
                                </p>
                            }
                            {mailLoading ? (
                                <Loader />
                            ) : (
                                <form className="form-inline">
                                    <input
                                        type="email"
                                        className="form-control mb-2 mr-sm-2 mb-sm-0"
                                        id="inlineFormInput"
                                        onChange={this.handleMailChange}
                                        value={email}
                                    />
                                    <button
                                        type="submit"
                                        className="btn btn-secondary"
                                        onClick={this.sendMail}
                                    >
                                        {
                                            send
                                                ? 'Verstuur opnieuw'
                                                : 'Verstuur via e-mail'
                                        }
                                    </button>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </View>
        );
    }
}

const stateSignal = {
    trackEvent: signal`app.trackEvent`,
    mailPdf: signal`app.mailPdf`,
    mailLoading: state`app.mail.loading`,
    error: state`app.mail.error`,
};

export default connect(
    stateSignal,
    PosterPreview
);



// WEBPACK FOOTER //
// ./src/pages/PosterPreview.js